import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { GeniusScoreboard } from 'src/domains/sportsbook/webview/components/scoreboards/genius/GeniusScoreboard';
import { GeniusGameTracker } from 'src/domains/sportsbook/webview/components/scoreboards/genius/GeniusGameTracker';
import { getGeniusWidgetConfig } from 'src/domains/sportsbook/webview/components/scoreboards/genius/getGeniusWidgetConfig';
import { GeniusAvailabilityState } from 'src/domains/sportsbook/state/geniusState/GeniusAvailabilityState';

interface GeniusWidgetsPropsType {
    event: EventModel;
}

export const GeniusWidgets = observer('GeniusWidgets', ({ event }: GeniusWidgetsPropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const widgetConfig = getGeniusWidgetConfig(event, config);

    if (widgetConfig === null) {
        return null;
    }

    if (widgetConfig.kind === 'scoreboard') {
        return <GeniusScoreboard event={event} />;
    }

    const { geniusScoreboard, fixtureId } = widgetConfig;
    const availability = GeniusAvailabilityState.get(common).getGameTrackerAvailability(
        geniusScoreboard.baseUrl,
        geniusScoreboard.productName,
        fixtureId
    );

    if (availability === 'loading') {
        return null;
    }

    if (availability === 'unavailable') {
        return (
            <GeniusScoreboard
                event={event}
                ignoreKindCheck
            />
        );
    }

    return <GeniusGameTracker event={event} />;
});
